import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-slate-200 last:border-0" data-id="element-1">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-4 flex items-center justify-between text-left focus:outline-none group" aria-expanded={isOpen} data-id="element-2">
        <span className="font-sans font-bold text-slate-900 text-lg group-hover:text-emerald-700 transition-colors" data-id="element-3">
          {question}
        </span>
        {isOpen ? <ChevronUp className="text-emerald-600 flex-shrink-0 ml-4" data-id="element-4" /> : <ChevronDown className="text-slate-400 group-hover:text-emerald-600 flex-shrink-0 ml-4 transition-colors" data-id="element-5" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 mb-4' : 'max-h-0 opacity-0'}`} data-id="element-6">
        <p className="font-serif text-slate-600 leading-relaxed pr-8" data-id="element-7">
          {answer}
        </p>
      </div>
    </div>;
}